import React from 'react';
import '../styles/Hero.css';
import { motion } from 'framer-motion';

function Hero() {
  return (
    <section className="hero">
      <img src="/images/interior_2.webp" alt="Arine" className="hero-image" />
      <div className="hero-overlay">
        <motion.div 
          className="hero-content glass-card"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h2>Extensiones de Pestañas en Madrid</h2>
          <p>Resultados espectaculares y personalizados para realzar tu belleza natural</p>
          <a href="#contact" className="btn">Reserva tu cita</a>
        </motion.div>
      </div>
    </section>
  );
}

export default Hero;